// Generated by CoffeeScript 2.7.0
var Admin__SessionsController;

export default Admin__SessionsController = class Admin__SessionsController extends Skylark.App.BaseController {
  new() {
    this.qrcodeContainer = DomMaster.find('.qrcode');
    this.hint = DomMaster.find('.hint');
    this.signedUrl = Skylark.Helpers.UrlHelper.adminUrlFor('signed', currentNamespace.id ? {
      _ns_id: currentNamespace.id
    } : void 0);
    this._generateQRCode();
    this._bindQRCodeEvent();
    return this._doSignedRequest();
  }

  _bindQRCodeEvent() {
    return this.qrcodeContainer.node.proxy('click', '.js-qrcode-refresh', function() {
      return location.reload();
    });
  }

  _generateQRCode() {
    var QRCode_el, size;
    this.qrcodeContainer.removeClass('.expired');
    QRCode_el = this.qrcodeContainer.find('.js-qrcode');
    size = QRCode_el.node.getBoundingClientRect().width;
    return QRCode.toCanvas(QRCode_el.node, QRCode_el.data('url'), {
      margin: 0,
      width: size
    }, _.noop);
  }

  _qrcodeExpiredFunc() {
    this.hint.html('二维码过期，点击刷新');
    return this.qrcodeContainer.addClass('expired');
  }

  _doSignedRequest() {
    return Skylark.Libs.Ajax.get(this.signedUrl, {
      contentType: 'application/json; charset=utf-8',
      responseType: 'script'
    });
  }

};

Skylark.App.Controllers.register({Admin__SessionsController});
